<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex-space-between">
            <span class="title">Pre-approved channels</span>
            <div>
              <el-button
                class="mr10"
                type="primary"
                round
                icon="el-icon-download"
                @click="CSVexport()"
              >
                Download CSV
              </el-button>
              <el-button
                class="mr10"
                type="primary"
                round
                icon="el-icon-upload2"
                @click="importCSV()"
              >
                Import CSV
              </el-button>
              <el-tooltip content="Add channel" placement="top">
                <el-button
                  type="success"
                  circle
                  icon="el-icon-check"
                  @click="setDialog(true)"
                ></el-button>
              </el-tooltip>
              <Dialog />
            </div>
          </div>
          <Table />
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      :title="invalidList.length > 0 ? 'Export Invalid Channels' : 'Import CSV'"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div v-if="invalidList.length > 0" class="align-center">
        <el-button class="mb10" type="info" @click="exportCSVInvalid()">
          Download CSV
        </el-button>
      </div>
      <div v-else>
        <el-upload
          drag
          ref="upload"
          accept=".csv"
          :action="`${admin}preapproved/csv/import`"
          :headers="headers"
          :file-list="fileList"
          :on-success="onSuccess"
          :on-error="onError"
          name="csv"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">*only csv files allowed</div>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from '../components/pre-approved/Table'
import Dialog from '../components/pre-approved/Dialog'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  data() {
    return {
      dialog: false,
      fileList: [],
      invalidList: [],
      url: process.env.VUE_APP_STORAGE_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      admin: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }
  },

  computed: {
    ...mapState('preapproved', ['loading'])
  },

  methods: {
    ...mapMutations('preapproved', ['setDialog']),
    ...mapActions('preapproved', ['CSVexport', 'read']),

    onSuccess(res) {
      this.dialog = false
      this.read()
      this.fileList = []
      if (res.response.message === 'Success.') {
        this.$message({
          message: res.response.message,
          type: 'success'
        })
      } else {
        this.$message({
          message: res.response.message,
          type: 'error'
        })
      }
    },
    onError(err) {
      this.fileList = []
      let res = JSON.parse(err.message)
      this.invalidList = res.data.errors
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },
    importCSV() {
      this.dialog = true
    },
    exportCSVInvalid() {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        Object.keys(this.invalidList[0]).join(';'),
        ...this.invalidList.map(item => Object.values(item).join(';'))
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', 'invalid_channels.csv')
      link.click()      
      this.dialog = false
      this.fileList = []   
      this.invalidList = []   
      this.read()
    },
    closeDialog(){
      this.dialog = false
      this.read()
    }
  }
}
</script>
